import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Store } from "@ngxs/store";
import { AuthService, Environment, EnvironmentService } from "@cloud-and-service/portal-lib";
import { MainState } from "@cloud-and-service/portal-lib";
import { Observable, from, switchMap } from "rxjs";

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
    environment: Environment;

    private refreshInProgress: Promise<any> | null = null;

    constructor(
        private store: Store,
        private authService: AuthService,
        environmentService: EnvironmentService
    ) {
        this.environment = environmentService.getEnvironment();
    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const auth = this.store.selectSnapshot(MainState.auth);
        const isLoggedIn = auth && auth.token;
        const isApiUrl = request.url.startsWith(this.environment.apiUrl);

        if (!isLoggedIn || !isApiUrl) {
            return next.handle(request);
        }

        const isRefreshRequest = request.url.includes('/auth/token/refresh');
        if (!isRefreshRequest && this.isTokenExpiredOrNearExpiry(auth.token)) {
            if (!this.refreshInProgress) {
                this.refreshInProgress = this.authService.refreshToken().finally(() => {
                    this.refreshInProgress = null;
                });
            }
            return from(this.refreshInProgress).pipe(
                switchMap(() => {
                    const refreshedAuth = this.store.selectSnapshot(MainState.auth);
                    const cloned = refreshedAuth?.token
                        ? request.clone({ setHeaders: { authorization: `Bearer ${refreshedAuth.token}` } })
                        : request;
                    return next.handle(cloned);
                })
            );
        }

        request = request.clone({
            setHeaders: { authorization: `Bearer ${auth.token}` }
        });
        return next.handle(request);
    }

    private isTokenExpiredOrNearExpiry(token: string, bufferSeconds: number = 30): boolean {
        try {
            const jwtToken = JSON.parse(atob(token.split('.')[1]));
            return Date.now() > jwtToken.exp * 1000 - bufferSeconds * 1000;
        } catch {
            return false;
        }
    }
}
